module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_8011.c6edefed.png";